/*
 * @Author: your name
 * @Date: 2021-01-19 18:19:40
 * @LastEditTime: 2022-03-18 17:42:13
 * @LastEditors: wangshengqiang
 * @Description: In User Settings Edit
 * @FilePath: /za-dplatform-product-life/Users/zhongan/project/za-dplatform-main/za-dplatform-h5/src/components/Beneficiary/ItemRender.js
 */
import React, { useState } from 'react';
import { Input } from 'zarm';
import { FormItem } from '@/baseComponents';
import { CPopup, ButtonDelete } from '../common';

const getPreLeveFormKey = formKey => {
  const keys = formKey.split(/\.|\[/g);
  const nextkeys = keys.map(i => {
    if (/\]/g.test(i)) {
      return `[${i}`;
    }

    return i;
  });
  nextkeys.pop();
  const preKey = nextkeys.join('.').replaceAll('.[', '[');
  return preKey;
};

export default function BeneficiaryRender({
  prefix,
  total,
  index,
  Render,
  preview,
  config,
  onDelete,
  form
}) {
  var _config$;

  const [visible, setVisible] = useState(preview);

  const handleDelete = () => {
    onDelete(index);
  };

  const preFormKey = getPreLeveFormKey((_config$ = config[0]) === null || _config$ === void 0 ? void 0 : _config$.formKey);

  function handleBeneficiaryInputOk() {
    form.validateFields([preFormKey]).then(vals => {
      setVisible(false);
    });
  }

  const title = /*#__PURE__*/React.createElement(ButtonDelete, {
    left: prefix + (index + 1),
    showDelete: total > 1,
    onDelete: () => handleDelete()
  });
  const formItemProps = {
    hasArrow: true,
    name: `${preFormKey}.name`,
    label: title,
    fieldOption: {
      rules: [{
        required: true,
        message: '请输入'
      }]
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormItem, formItemProps, /*#__PURE__*/React.createElement(Input, {
    placeholder: "\u586B\u5199\u4FE1\u606F",
    onClick: () => setVisible(true)
  })), /*#__PURE__*/React.createElement(CPopup, {
    visible: visible,
    title: "\u586B\u5199\u53D7\u76CA\u4EBA\u4FE1\u606F",
    onHide: () => {
      setVisible(false);
    },
    onRightClick: () => {
      handleBeneficiaryInputOk();
    }
  }, /*#__PURE__*/React.createElement(Render, {
    components: config
  })));
}